export default __webpack_public_path__ + "static/media/everyday.514f1cc7.svg";